const providers = {
  TWITTER: 'twitter',
};

export default providers;



// WEBPACK FOOTER //
// ./src/payments/constants/SocialPayConstants.js